import { render, staticRenderFns } from "./browserList.vue?vue&type=template&id=50636ac4&scoped=true&"
import script from "./browserList.vue?vue&type=script&lang=js&"
export * from "./browserList.vue?vue&type=script&lang=js&"
import style0 from "./browserList.vue?vue&type=style&index=0&id=50636ac4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50636ac4",
  null
  
)

export default component.exports